var _style, _g, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "1707px",
    height: "750px",
    viewBox: "0 0 1707 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill-opacity:0.9608;}\n\t.st2{fill:#02A5B8;fill-opacity:0.9608;}\n\t.st3{fill:#00A5B8;}\n\t.st4{fill:#02A5B8;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#FFFFFF;fill-opacity:0.9608;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "layer3_00000088822779015949611960000001749892566684438413_",
    transform: "translate(-28.757263,-5.781242)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M742.8,605.8L742.8,605.8c-22.6,0-41-18.4-41-41V388.9c0-22.6,18.4-41,41-41h0c22.6,0,41,18.4,41,41v175.9 C783.8,587.4,765.4,605.8,742.8,605.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1396-1-5-2-7_00000158727495076952106020000015134636859483039133_",
    className: "st2",
    d: "M1173.8,46.8v432.6L948,210.4 c-7.8-9.3-19.3-14.6-31.4-14.6h-21.9c-22.6,0-41,18.4-41,41v478c0,22.6,18.4,41,41,41h0c22.6,0,41-18.4,41-41V322.2l225.7,269 c7.8,9.3,19.3,14.6,31.4,14.6h21.9c22.6,0,41-18.4,41-41v-518c0-22.6-18.4-41-41-41l0,0C1192.1,5.8,1173.8,24.1,1173.8,46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1396-1-5-8_00000119096856477828745800000009771865826359663241_",
    className: "st2",
    d: "M351.5,195.8 c-70.2,0-127.4,58.1-124.4,128.3c2.8,65.5,56.8,117.7,122.9,117.7l0,0v-81.9c0-0.1,0-0.1-0.1-0.1c-22.6-0.1-40.9-18.4-40.9-41l0,0 c0-22.6,18.4-41,41-41l0,0h205c22.6,0,41-18.4,41-41v0c0-22.6-18.4-41-41-41H351.5z M350,359.9v81.8c0,0.1,0,0.1,0.1,0.1h158.7 c22.6,0,41,18.4,41,41l0,0c0,22.6-18.4,41-41,41h-439c-22.6,0-41,18.4-41,41v0c0,22.6,18.4,41,41,41h437.5 c70.2,0,127.4-58.1,124.4-128.3c-2.8-65.5-56.8-117.7-122.9-117.7L350,359.9C350,359.8,350,359.8,350,359.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4412_00000078735082342978293580000002531943665721218188_",
    transform: "translate(13.805411,-45.468758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1821_00000147183951260487006670000005830302313085923747_",
    className: "st2",
    d: "M1517,241.3c-113.2,0-205,91.8-205,205 l0,0c0,113.2,91.8,205,205,205l0,0c113.2,0,205-91.8,205-205S1630.2,241.3,1517,241.3z M1517,325.4 c66.8,0,120.9,54.2,120.9,120.9s-54.2,121-120.9,121c-66.8,0-121-54.2-121-120.9l0,0C1396.1,379.5,1450.2,325.4,1517,325.4 L1517,325.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path4299_00000121277165231810727290000003705420592096004741_",
    className: "st2",
    cx: 1517,
    cy: 446.3,
    r: 41
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1821_00000044153012419858760420000009454430631565423534_",
    className: "st2",
    d: "M1517,241.4c-113.2,0-205,91.8-205,205 l0,0c0,113.2,91.8,205,205,205l0,0c113.2,0,205-91.8,205-205S1630.2,241.4,1517,241.4z M1517,325.5 c66.8,0,120.9,54.2,120.9,120.9s-54.2,121-120.9,121c-66.8,0-121-54.2-121-120.9l0,0C1396.1,379.6,1450.2,325.5,1517,325.5 L1517,325.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M631.8,236.9L631.8,236.9c0,22.6-18.4,41-41,41H361v-82h229.7C613.4,195.9,631.8,214.2,631.8,236.9z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1325.4,499.9l144.3,230.4c16.4,26.2,48.2,26.2,64.6,0l144.2-230.4L1501.9,590L1325.4,499.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 714,
    cy: 231.1,
    r: 41.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSino);
export default __webpack_public_path__ + "static/media/logo_sino.799f6690d420e6897042498ec66a66a5.svg";
export { ForwardRef as ReactComponent };